"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_app__cloud__dvr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:8px;}")), /*#__PURE__*/React.createElement("title", null, "APP-cloud-DVR"), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.41,50"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.28,119.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.89,148s5.35.19,13.64-3.18c12.57-5.11,20.94-18.19,22.28-31.69a34.92,34.92,0,0,0-15.95-33.22c-5.6-3.49-12.15-4.9-18.7-5.48a77.61,77.61,0,0,0-11.18.51,44.83,44.83,0,0,0-4.27-9.57c-7.11-12-20.27-20.21-33.65-21.25A42.38,42.38,0,0,0,52.35,59.37,44.78,44.78,0,0,0,43.44,77c-.43,1.71-1.28,6.49-1.28,6.49A33.43,33.43,0,0,0,30.3,90.33c-10.51,9.49-13.07,25.08-7.19,37.84C28.45,139.75,39.55,148,52.31,148h83.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60,98.27v27.32A2.41,2.41,0,0,0,62.33,128a2.47,2.47,0,0,0,1.54-.47l.34-.24,18.19-13,.54-.38a2.23,2.23,0,0,0,.67-3.16,2.38,2.38,0,0,0-.69-.65l-.52-.38-18.12-13a2.65,2.65,0,0,0-2.78-.57A2.48,2.48,0,0,0,60,98.46v.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 115.74,
    y1: 96,
    x2: 115.74,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 131.74,
    y1: 96,
    x2: 131.74,
    y2: 128
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.81,102"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 192,
    height: 192
  }));
}

var _default = ic_app__cloud__dvr;
exports.default = _default;